import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import Feedback from "@mui/icons-material/Feedback";
import InsertComment from "@mui/icons-material/InsertComment";

// core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import OthelloBotonera from '../componentsothello/OthelloBotonera.jsx';
import { TipoOthelloFieldGrid, DataStatePage, TiposPreguntaEncuenta, OpcionVisibilidad, PopUpResult, TiposValidacionEncuenta, TiposEncuenta, OpcionSiNo } from "../othelloConstantes.jsx";
import OthelloGrid from '../componentsothello/OthelloGrid.jsx';
import OthelloEdit from '../componentsothello/OthelloEdit.jsx';
import OthelloTituloPanelData from "../componentsothello/OthelloTituloPanelData.jsx";


import ImageUpload from "../components/ImageUpload.jsx";
import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import Button from "../components/Button.jsx";
import MDTypography from "../components/MDTypography/index.js";


export default function Encuestas({ ...props }) {
    const { literal, idRol } = props;

    const [loading, setLoading] = React.useState(true);

    const [statePage, setstatePage] = React.useState(DataStatePage.dsSearch);
    const [stateQuestionPage, setstateQuestionPage] = React.useState(DataStatePage.dsSearch);
    const [dataenc, setdataenc] = React.useState(null);
    const [dataquestion, setdataquestion] = React.useState(null);
    const [urlencuesta, seturlencuesta] = React.useState("");

    const [alert, setalert] = React.useState(null);

    const [dataeditando, setdataeditando] = useState(null);
    const [indexeditando, setindexeditando] = useState(null);

    const [dataquestioneditando, setdataquestioneditando] = useState(null);
    const [indexquestioneditando, setindexquestioneditando] = useState(null);

    React.useEffect(() => {

        setLoading(false);
        getDataPage();
    }, [loading]);

    //METODOS GLOBALES DE LA PAGINA

    //Metodoso sobre Encuestas

    const getDataPage = () => {

        fetch('api/Data/GetEncuestas')
            .then(response => response.json())
            .then(data => {
                setdataenc(data);
            });
    }

    const getDataVacia = () => {

        fetch('api/Data/GetEncuestaVacia')
            .then(response => response.json())
            .then(data => {
                setdataeditando(data);
                setstatePage(DataStatePage.dsInsert);

            }).catch(error => {
                setdataeditando(null);
            });;
    }

    const grabarDataPage = (event) => {

        //Obtengo los datos
        let formulario = document.getElementById('formencuesta');
        let formData = new FormData(formulario);
        //const data = new FormData(this.refs.form);

        fetch('api/Data/GrabarEncuesta', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            //Si estamos añadiendo uno nuevo lo meto dentro de la lista de regiones
            if (indexeditando == -1) {
                var array = [...dataenc];
                array.push(res);

                setdataenc(array);
            }
            //Sino, es que estamos editando uno
            else {
                var array = [...dataenc];
                array[indexeditando] = res;
                setdataenc(array);
            }

            setdataeditando(null);
            setindexeditando(null);
            setdataquestioneditando(null);
            setindexquestioneditando(null);

            setstatePage(DataStatePage.dsSearch);
            setalert(PopUpResult.OK);


        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPage = () => {
        //LLama a obtener el idioma vacio, que es el que pondra el estado
        getDataVacia();
        setindexeditando(-1);
    }

    const cancelarDataPage = () => {
        setdataeditando(null);
        setindexeditando(null);
        setdataquestioneditando(null);
        setindexquestioneditando(null);
        setstatePage(DataStatePage.dsSearch);
        seturlencuesta("");
    }

    const deshacerDataPage = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditando == -1) {
            setstatePage(DataStatePage.dsSearch);
            seturlencuesta("");
        }
        //Sino, es que estabamos en un item valido
        //else 
        //  this.forceUpdate()                   
    }

    const onClosePopUpResult = () => {
        setalert(null);
    }

    const getUrlEncuesta = (valor) => {
        var jsonData = JSON.stringify(valor.id_Encuesta);

        fetch('api/Data/GetUrlEncuesta', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {

            seturlencuesta(res);
        }).catch(error => {

        });
    }


    //Metodoso sobre Questions

    const getDataVaciaQuestion = () => {

        var jsonData = JSON.stringify(dataeditando.id_Encuesta);

        fetch('api/Data/GetQuestionVacia', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {
            setdataquestioneditando(res);
            setstateQuestionPage(DataStatePage.dsInsert);
        }).catch(error => {
            setdataquestioneditando(null);
        });
    }

    const grabarDataPageQuestion = (event) => {
        //Obtengo los datos
        let formulario = document.getElementById('formQuestion');
        let formData = new FormData(formulario);
        //const data = new FormData(this.refs.form);

        fetch('api/Data/GrabarQuestion', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            //Si estamos añadiendo uno nuevo lo meto dentro de la lista de regiones
            if (indexquestioneditando == -1) {

                var array = [...dataquestion];
                array.push(res);

                setdataquestion(array);
            }
            else {
                var array = [...dataquestion];
                array[indexquestioneditando] = res;
                setdataquestion(array);
            }

            setdataquestioneditando(null);
            setindexquestioneditando(null);

            setstateQuestionPage(DataStatePage.dsSearch);
            seturlencuesta("");
            setalert(PopUpResult.OK);


        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPageQuestion = () => {
        //LLama a obtener el idioma vacio, que es el que pondra el estado
        getDataVaciaQuestion();
        setindexquestioneditando(-1)
    }

    const cancelarDataPageQuestion = () => {
        setdataquestioneditando(null);
        setindexquestioneditando(null);

        setstateQuestionPage(DataStatePage.dsSearch);

    }

    const deshacerDataPageQuestion = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexquestioneditando == -1)
            setstateQuestionPage(DataStatePage.dsSearch);
        //Sino, es que estabamos en un item valido
        //else
        //  this.forceUpdate()
    }

    //METODO SOBRE EL GRID ENCUESTAS   
    const editGridDataPage = (valor, index) => {

        setdataeditando(valor);
        setindexeditando(index);

        //Al editar otra concreta limpiamos la posible Question seleccionada
        setdataquestioneditando(null);
        setindexquestioneditando(null);

        //Si no tiene Questions entonces directamente lo pongo en edicion y limpio la lista de Questions
        if (valor.tieneQuestions == 0) {
            setdataquestion([]);
            setstatePage(DataStatePage.dsEdit);
            setstateQuestionPage(DataStatePage.dsSearch);
        }
        //sino, es que tiene Questions, por tanto las pido
        else {
            if (valor != null) {
                var jsonData = JSON.stringify(valor.id_Encuesta);

                fetch('api/Data/GetQuestions', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: jsonData

                }).then(response => response.json()).then(res => {
                    setdataquestion(res);
                    setstatePage(DataStatePage.dsEdit);
                    setstateQuestionPage(DataStatePage.dsSearch);
                }).catch(error => {

                });
            }
        }
    }

    const deleteGridDataPage = (valor, index) => {


        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Encuesta);

            fetch('api/Data/EliminarEncuesta', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                if (res) {
                    //Si todo salie correcto limpio los valores de edicion
                    setdataeditando(valor);
                    setindexeditando(index);


                    if (dataenc != null) {
                        var array = [...dataenc]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        //Modificao el estado de data para que refresque la pantalla
                        setdataenc(array);

                        setdataquestion([]);
                        setstatePage(DataStatePage.dsSearch);
                        setstateQuestionPage(DataStatePage.dsSearch);
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    //METODO SOBRE EL GRID QuestionS
    const editGridDataPageQuestion = (valor, index) => {

        setdataquestioneditando(valor);
        setindexquestioneditando(index);
        setstateQuestionPage(DataStatePage.dsEdit);
    }

    const deleteGridDataPageQuestion = (valor, index) => {

        if (valor != null) {

            var jsonData = JSON.stringify({ idofi: valor.id_Oficina, idencuesta: valor.id_Encuesta, idquestion: valor.id_Question });

            fetch('api/Data/EliminarQuestion', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {
                    //Si todo salie correcto limpio los valores de edicion
                    setdataquestioneditando(valor);
                    setindexquestioneditando(index);

                    if (dataquestion != null) {
                        var array = [...dataquestion]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        setdataquestion(array);
                        setalert(PopUpResult.OK);                      
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    //METODOS DE RENDERIZADO DE LA PANTALLA

    function renderSearch(encuestas) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = ["Encuesta", "Visible", "Validacion", "Imagen", "Preguntas"];

        let valoreshow = ["nombre", "visible", "tipoValidacion", "image", "tieneQuestions"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "tipoValidacion", items: TiposValidacionEncuenta });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloImagen, fieldname: "image", items: [] });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "visible", items: OpcionVisibilidad });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={encuestas} datasourcefields={datasourceFields} onEdit={editGridDataPage} onDelete={deleteGridDataPage} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={10} />);
    }

    function renderInsertEdit(enc) {

        if (enc != null) {
            let Nombre = enc != null && enc.id_Encuesta > 0 ? "Editar " + enc.nombre : "Nueva Encuesta";

            let infoQuestions = renderOpcionesQuestions();

            return (<OthelloTituloPanelData icon="feedback" titulo={Nombre} margentop={4}>
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    <Grid container>
                        <Grid item xs={12} >
                            <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} onGrabar={grabarDataPage} onCancel={cancelarDataPage} onDeshacer={deshacerDataPage} />
                        </Grid>
                    </Grid>
                    <form id="formencuesta" >
                        <Grid container>
                            <input id="Id_Oficina" name="id_Oficina" type="hidden" value={enc.id_Oficina} />
                            <input id="Id_Encuesta" name="Id_Encuesta" type="hidden" value={enc.id_Encuesta} />
                            <Grid item xs={12} sm={2}>
                                <OthelloEdit label="Nombre" fieldname="nombre" currentvalue={enc.nombre} />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <OthelloComboBox label='Validacion' fieldname="tipoValidacion" items={TiposValidacionEncuenta} currentvalue={enc.tipoValidacion} />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <OthelloComboBox label='Tipo Encuesta' fieldname="tipoEncuesta" items={TiposEncuenta} currentvalue={enc.tipoEncuesta} />
                            </Grid>
                            <Grid item xs={12} sm={1}>
                                <OthelloComboBox label='Visible' fieldname="visible" items={OpcionVisibilidad} currentvalue={enc.visible} />
                            </Grid>
                            <Grid item xs={5} sm={2} lg={1}>
                                <OthelloEdit label="Latitud" fieldname="latStringAux" currentvalue={enc.lat} />
                            </Grid>
                            <Grid item xs={5} sm={2} lg={1}>
                                <OthelloEdit label="Longitud" fieldname="lonStringAux" currentvalue={enc.lon} />
                            </Grid>
                            <Grid item xs={10} sm={2}>
                                <OthelloComboBox label='Mail Final Encuesta' fieldname="enviaMailFinEncuesta" items={OpcionSiNo} currentvalue={enc.enviaMailFinEncuesta} />
                            </Grid>
                            <Grid item xs={12} sm={1}>
                                <OthelloEdit label="BackColor" fieldname="BackColor" currentvalue={enc.backColor} />
                            </Grid>
                        </Grid>
                        <Grid container xs={12}>
                            <Grid item xs={12} sm={6}>
                                <OthelloEdit label="Descripcion" fieldname="descripcion" currentvalue={enc.descripcion} rows={3} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <OthelloEdit label="Info Inicial" fieldname="infoInicial" currentvalue={enc.infoInicial} rows={3} />
                            </Grid>
                        </Grid>                      
                        <Grid container xs={12}>
                            <Grid item xs={12} sm={6}>
                                <OthelloEdit label="Info Adicional" fieldname="infoAdicional" currentvalue={enc.infoAdicional} rows={3} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <OthelloEdit label="NormasEncuesta" fieldname="normasEncuesta" currentvalue={enc.normasEncuesta} rows={3} />
                            </Grid>                           
                        </Grid>
                        <Grid container xs={12}>
                            <Grid item xs={12} sm={6}>
                                <OthelloEdit label="Titulo Fin Encuesta" fieldname="tituloFinEncuesta" currentvalue={enc.tituloFinEncuesta} rows={3} />
                            </Grid>                            
                            <Grid item xs={12} sm={6}>
                                <OthelloEdit label="Texto Fin Encuesta" fieldname="textoFinEncuesta" currentvalue={enc.textoFinEncuesta} rows={3} />
                            </Grid>
                        </Grid>
                        <Grid container xs={12}>
                            <Grid item xs={12} sm={4}>
                                <OthelloEdit label="Inicio Ficha" fieldname="InicioFicha" currentvalue={enc.inicioFicha} rows={3} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <OthelloEdit label="Ubicacion Ficha" fieldname="UbicacionFicha" currentvalue={enc.ubicacionFicha} rows={3} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <OthelloEdit label="Descripcion Ficha" fieldname="DescripcionFicha" currentvalue={enc.descripcionFicha} rows={3} />
                            </Grid>                                                                                
                        </Grid>
                        <Grid container xs={12}>
                            <Grid item xs={12} sm={2}>
                                <OthelloEdit label="Agrupacion (UnionEncuestas)" fieldname="Agrupacion" currentvalue={enc.agrupacion} />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <OthelloEdit label="Idioma" fieldname="Idioma" currentvalue={enc.idioma} />
                            </Grid>  
                            <Grid item xs={12} sm={2}>
                                <OthelloEdit label="Orden Visual" fieldname="OrdenVisual" currentvalue={enc.ordenVisual} />
                            </Grid>                                                       
                        </Grid>       
                        <Grid container>
                            <Grid item xs={12} sm={2}>
                                <br />
                                <legend>Imagen</legend>
                                <ImageUpload
                                    id="Image" name="image"
                                    imageUrl={enc.image}
                                    addButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    changeButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    removeButtonProps={{
                                        color: "danger",
                                        round: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <br />
                                <legend>Imagen Avatar</legend>
                                <ImageUpload
                                    id="ImageAvatar" name="imageAvatar"
                                    imageUrl={enc.imageAvatar}
                                    addButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    changeButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    removeButtonProps={{
                                        color: "danger",
                                        round: true
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <hr />
                    <Grid container>
                        <Grid item xs={12} sm={2}  >
                            {enc != null && enc.id_Encuesta > 0 ? <Button size='sm' color='info' onClick={() => getUrlEncuesta(enc)}>Ver Url Encuesta</Button> : ""}                            
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            {urlencuesta != null ? urlencuesta : ""}
                        </Grid>
                        <Grid item xs={12}>  
                            <MDTypography color="error" fontSize={12} mt={1}> /***** NOTA: https://juegos.ovtspain.es/game/play en el caso de se juego *******/</MDTypography>
                        </Grid>
                    </Grid>
                    <hr />
                    <Grid container>
                        <Grid item xs={12} >
                            {infoQuestions}
                        </Grid>
                    </Grid>

                </div>
            </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    function renderOpcionesQuestions() {
        let busquedaQuestions = renderSearchQuestions(dataquestion);

        let edicion = stateQuestionPage == DataStatePage.dsEdit || stateQuestionPage == DataStatePage.dsInsert ? renderInsertEditQuestion(dataquestioneditando) : "";
        //#99d9b7
        return (<OthelloTituloPanelData icon="insert_comment" tituloliteral="_preguntas" margentop={4} backcoloretiqueta="#709e86" bgcoloricon="success">            
            <div style={{ backgroundColor: '#FFFFFF' }}>
                <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                        {edicion}
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} >
                        <OthelloBotonera statePage={stateQuestionPage} onNuevo={nuevoDataPageQuestion} forzarnuevo={true} />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} >
                        {busquedaQuestions}
                    </Grid>
                </Grid>
            </div>
        </OthelloTituloPanelData>);
    }

    function renderSearchQuestions(Questions) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = ["Pregunta", "Tipo", "Orden Visual", "Visible"];
        let valoreshow = ["pregunta", "tipo", "ordenVisual", "visible"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "tipo", items: TiposPreguntaEncuenta });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "visible", items: OpcionVisibilidad });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={Questions} datasourcefields={datasourceFields} onEdit={editGridDataPageQuestion} onDelete={deleteGridDataPageQuestion} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={5} />);
    }

    function renderInsertEditQuestion(Question)
    {
        if (Question != null) {
            let Nombre = Question != null && Question.id_Question > 0 ? "Editar " + Question.pregunta : "Nueva Pregunta";

            return (<div style={{ backgroundColor: '#f0f0f0', padding: '10px', marginBottom: '10px' }}>
                <Grid container xs={12}>
                    <Grid item xs={12} >
                        <h4>{Nombre}</h4>
                    </Grid>
                </Grid>
                <Grid container xs={12}>
                    <Grid item xs={12} >
                        <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPageQuestion} onGrabar={grabarDataPageQuestion} onCancel={cancelarDataPageQuestion} onDeshacer={deshacerDataPageQuestion} />
                    </Grid>
                </Grid>
                <form id="formQuestion" >
                    <Grid container xs={12}>
                        <input id="Id_Oficina" name="Id_Oficina" type="hidden" value={Question.id_Oficina} />
                        <input id="Id_Encuesta" name="Id_Encuesta" type="hidden" value={Question.id_Encuesta} />
                        <input id="Id_Question" name="Id_Question" type="hidden" value={Question.id_Question} />
                        <Grid item xs={12} sm={4}>
                            <OthelloEdit label="Pregunta" fieldname="Pregunta" currentvalue={Question.pregunta} />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <OthelloComboBox label='Tipo' fieldname="tipo" items={TiposPreguntaEncuenta} currentvalue={Question.tipo} />
                        </Grid>
                        <Grid item xs={12} sm={1}>
                            <OthelloComboBox label='Visible' fieldname="visible" items={OpcionVisibilidad} Question={Question.visible} />
                        </Grid>                       
                        <Grid item xs={12} sm={1}>
                            <OthelloEdit label="Orden Visual" fieldname="OrdenVisual" currentvalue={Question.ordenVisual} />
                        </Grid>                      
                        <Grid item xs={5} sm={2} lg={1}>
                            <OthelloEdit label="Latitud" fieldname="latStringAux" currentvalue={Question.lat} />
                        </Grid>
                        <Grid item xs={5} sm={2} lg={1}>
                            <OthelloEdit label="Longitud" fieldname="lonStringAux" currentvalue={Question.lon} />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <OthelloEdit label="Valor Defecto/Respuesta" fieldname="DefaultValue" currentvalue={Question.defaultValue} />
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <Grid item xs={12} sm={12}>
                            <OthelloEdit label="Valores Opc. Combo (ej: A|B|C..) o Num Filas TextoLibre o Pistas (ej:P1|P2|P3-Respuesta)" fieldname="opciones" currentvalue={Question.opciones} />
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <Grid item xs={12} sm={12}>
                            <OthelloEdit label="Descripcion" fieldname="descripcion" currentvalue={Question.descripcion} rows={3} />                            
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <Grid item xs={12} sm={6}>
                            <OthelloEdit label="Info Inicial" fieldname="infoInicial" currentvalue={Question.infoInicial} rows={3} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <OthelloEdit label="Info Adicional" fieldname="infoAdicional" currentvalue={Question.infoAdicional} rows={3} />                            
                        </Grid>
                    </Grid>                                       
                    <Grid container>
                        <Grid item xs={12} sm={2}>
                            <br />
                            <legend>Imagen</legend>
                            <ImageUpload
                                id="Image" name="image"
                                imageUrl={Question.image}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                    </Grid>
                </form>
            </div>
            );
        }
        else
            return "";
    }

    let busqueda = loading ? <p><CircularProgress color="secondary" /></p> : renderSearch(dataenc)

    let edicion = statePage == DataStatePage.dsEdit || statePage == DataStatePage.dsInsert ? renderInsertEdit(dataeditando) : "";

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12}>
                {alerta}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                {edicion}
            </Grid>
            <Grid container>
                <Grid item xs={12} >
                    <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} forzarnuevo={true} />
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData tituloliteral="_encuestas" margentop={0}>
                    <Grid container>
                        <Grid item xs={12}>
                            {busqueda}
                        </Grid>
                    </Grid>
                </OthelloTituloPanelData>            
            </Grid>
        </Grid>
    );
}
